let initialState = {
    inf_0001: "Вы не ввели <b>Логин оператора</b> и <b>Пароль оператора</b> для входа в личный кабинет.",
    inf_0002: "Не верный логин или пароль.",
    inf_0003: "Вы действительно хотите выйти из системы?",
    
    warn_0001: "У Вас отсутствует доступ к разделу УМКД.",
    warn_0002: "У Вас отсутствует доступ к разделу Администрирование.",
    warn_0003: "У Вас отсутствует доступ к разделу Портфолио студента.",
    warn_0004: "У Вас отсутствует доступ к разделу Ввод оценок.",
    warn_0005: "У Вас отсутствует доступ к разделу РПД.",
    // warning_0001: "Оператор с таким <b>логином</b> уже существует в системе.",
    // warning_0002: "Вы не указали <b>логин</b> оператора.",
    // warning_0003: "Пароль не должен быть <b>меньше восьми символов</b>, пароль должен содержать <b>специальные символы</b>, <b>цифры</b>, </b>маленькие и заглавные</b> латинские буквы.",
    // warning_0004: "Вы не указали <b>фамилию</b> оператора.",
    // warning_0005: "Вы не указали <b>имя</b> оператора.",

    // err_api: "Код ошибки: API. </br> Ваш ключ приложения более не валидный. Попробуйте перезайти.",
    err_code: "Код ошибки NULL_CODE. </br> Сервер по не предвиденной причине не ответил.",

    err_0001: "Код ошибки: 0001. </br> Сервер временно не доступен.",
    err_0002: "Код ошибки: 0002. </br> Ошибка в запросе, при проверке оператора.",
    err_0003: "Код ошибки: 0003. </br> Вы не авторизованны в системе. Приложение будет работать не корректно. Пожалуйста переавторизуйтесь.",
    err_0004: "Код ошибки: 0004. </br> Дублирование записи, такая запись уже существует.",
    
    err_0010: "Код ошибки: 0010. </br> Ошибка в запросе, при получении данных профиля оператора.",
    err_0011: "Код ошибки: 0011. </br> Ошибка в запросе, при выходе из приложения.",
    err_0012: "Код ошибки: 0012. </br> Ошибка в запросе, при загрузке аватара оператора.",
    err_0013: "Код ошибки: 0013. </br> Файл не найден.",
    err_0014: "Код ошибки: 0014. </br> Не допустимое расширение файла. Разрешены файлы с расширением <b>.jpg</b> или <b>.png</b>",
    err_0015: "Код ошибки: 0015. </br> Файл не должен быть больше 2 мегабайт.",
    err_0016: "Код ошибки: 0016. </br> Ошибка в запросе, при изменении профиля оператора.",
    err_0017: "Код ошибки: 0017. </br> Ошибка в запросе, при загрузке направлений подготовки.",
    err_0018: "Код ошибки: 0018. </br> Ошибка в запросе, при загрузке специализаций.",
    err_0019: "Код ошибки: 0019. </br> Ошибка в запросе, при загрузке дисциплин.",
    err_0020: "Код ошибки: 0020. </br> Ошибка в запросе, при загрузке файлов.",
    err_0021: "Код ошибки: 0021. </br> Ошибка в запросе, при удалении файла.",
    err_0022: "Код ошибки: 0022. </br> Ошибка в запросе, при загрузке файла.",
    err_0023: "Код ошибки: 0023. </br> Не допустимое расширение файла. Разрешены файлы с расширением <b>.pdf</b>",
    err_0024: "Код ошибки: 0024. </br> Файл не должен быть больше 100 мегабайт.",
    err_0025: "Код ошибки: 0025. </br> Ошибка в запросе, при загрузке списка операторов системы.",
    err_0026: "Код ошибки: 0026. </br> Ошибка в запросе, при изменении уровня доступа оператора.",
    err_0027: "Код ошибки: 0027. </br> Ошибка в запросе, при загрузке списка уровней доступа УМКД.",
    err_0028: "Код ошибки: 0028. </br> Ошибка в запросе, при загрузке списка направлений подготовки.",
    err_0029: "Код ошибки: 0029. </br> Ошибка в запросе, при загрузке списка специализаций.",
    err_0030: "Код ошибки: 0030. </br> Ошибка в запросе, при удалении уровня доступа оператора.",
    err_0031: "Код ошибки: 0031. </br> Ошибка в запросе, при добавлении уровня доступа оператора.",
    err_0032: "Код ошибки: 0032. </br> Ошибка в запросе, при загрузке списка уровней доступа оператора.",
    err_0033: "Код ошибки: 0033. </br> Ошибка в запросе, при удалении уровней доступа оператора.",
    err_0034: "Код ошибки: 0034. </br> Ошибка в запросе, при добавлении уровней доступа оператора.",
    err_0035: "Код ошибки: 0035. </br> Ошибка в запросе, при добавлении нового оператора.",
    err_0036: "Код ошибки: 0036. </br> Ошибка в запросе, при изменении данных оператора.",
    err_0037: "Код ошибки: 0037. </br> Ошибка в запросе, при получении списка групп оператора.",
    err_0038: "Код ошибки: 0038. </br> Ошибка в запросе, при получении списка студентов.",
    err_0039: "Код ошибки: 0039. </br> Ошибка в запросе, при получении списка файлов студента.",
    err_0040: "Код ошибки: 0040. </br> Ошибка в запросе, при загрузке файла в портфолио студента.",
    err_0041: "Код ошибки: 0041. </br> Ошибка в имени файла, файл должен состоять из двух разделителей нижнего подчеркивания.",
    err_0042: "Код ошибки: 0042. </br> Ошибка в имени файла, префикс в имени файла не определен, возможно вы допустили ошибку.",
    err_0043: "Код ошибки: 0043. </br> Ошибка в имени файла, ФИО студента в базе данных и в имени файла не совпадают.",
    err_0044: "Код ошибки: 0044. </br> Ошибка в запросе, при удалении файла студента.",
    err_0045: "Код ошибки: 0045. </br> Ошибка в запросе, при создании направления подготовки.",
    err_0046: "Код ошибки: 0046. </br> Ошибка в запросе, при создании дисциплин.",
    err_0047: "Код ошибки: 0047. </br> Ошибка в запросе, при удалении дисциплины.",
    err_0048: "Код ошибки: 0048. </br> Ошибка в запросе, при редактировании дисциплины.",
    err_0049: "Код ошибки: 0049. </br> Ошибка в запросе, при удалении направления подготовки.",
    err_0050: "Код ошибки: 0050. </br> Ошибка в запросе, при редактировании направления подготовки.",
}

const messagesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        default: return state
    }
}

export default messagesReducer